import ReplayIcon from '@mui/icons-material/Replay';
import { Button, IconButton, useMediaQuery, useTheme } from '@mui/material';

export interface RetryButtonProps {
  onAction: () => void;
}

export default function RetryButton(props: RetryButtonProps) {
  const { onAction } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {!matches && (
        <Button variant="outlined" onClick={() => onAction()}>
          Retry
        </Button>
      )}

      {matches && (
        <IconButton aria-label="Retry" className="outlined" onClick={() => onAction()}>
          <ReplayIcon />
        </IconButton>
      )}
    </>
  );
}
